import { useContext, useEffect, useCallback } from 'react';
import { useStore } from 'react-redux';
import A from './ActionCreators';
import activeElementConsumesArrowKeys from './activeElementConsumesArrowKeys';

//import SelectedItemsRefContext from './SelectedItemProvider';

import { SelectedItemsDispatch, SelectedItemsRefContext } from './SelectedItemProvider';

import G from './Getters';

import { FigureModalArgs } from './FigureInteractionProvider';


const INPUT_TYPES = ["INPUT","TEXTAREA"];


const ARROW_KEYS = new Set(["ArrowUp","ArrowDown","ArrowLeft","ArrowRight"]);

const DELETE_KEYS = new Set(["Delete","Backspace"]);



export default function KeyDownListener({
  children,
  focusedOnValueDisplayRef, 
  figurePanelId,
  rowArrangedGridData
}){

  const store = useStore();

  const selectedItemsRef = useContext(SelectedItemsRefContext);
  const setSelectedItems = useContext(SelectedItemsDispatch);

  const modalArgs = useContext(FigureModalArgs);

  const handleKey = useCallback(e => {

    if( modalArgs ){
      return;
    }

    let { key } = e;

    let args = {
      key,store,selectedItemsRef,
      figurePanelId,
      event:e,
      setSelectedItems
    }
    if( ARROW_KEYS.has(key) ){
      handleArrowKey(args);
    }else if( DELETE_KEYS.has(key) ){
      handleDeleteKey(args)
    }
  },[store,selectedItemsRef,figurePanelId, modalArgs]);


  useEffect(() => {
    window.addEventListener('keydown',handleKey);
    return () => {
      window.removeEventListener('keydown',handleKey);
    }
  })
  

  return children;

}

function handleDeleteKey({key,store,selectedItemsRef,figurePanelId,setSelectedItems}){

  //;
  console.log("TRYIHNG TO DELETE!");

  let items = selectedItemsRef.getState();
  let expansionNodes = items?.expansionNodes;

  if( !expansionNodes ){ return; }

  if( document.activeElement?.tagName === "INPUT" ){
    return;
  }

  let dispatch = store.dispatch;

  setSelectedItems();
  dispatch(A.deleteEvaluatedExpansionContent({
    figurePanelId,
    items:expansionNodes
  }))



}

function handleArrowKey({figurePanelId,key,store,selectedItemsRef,figurePanel,event,setSelectedItems}){

      if( activeElementConsumesArrowKeys() ){
        return;
      }

      let state = store.getState();
      let doingWalkthrough = G.isInTutorial(state);


      if( doingWalkthrough ){
        console.log("No arrow keys while doing tutorial.");
        return;
      }


      //the only case where we do anything
      //is if the active element is 
      //the value display
      //but it's not "consuming"
      //meaning we're not trying to 
      //use arrow keys to navigate the 
      //value display
      //then, we intervene
      //and navigate the selection



      /*

      if( activeTag === 'INPUT' ){
        return;
      }else if( activeTag === 'TEXTAREA' ){
        if( focusedOnValueDisplayRef.current && e.key !== 'Enter' ){
          return;
        }
      }*/

      let directionMap = {
        ArrowUp:[-1,0],
        ArrowLeft:[0,-1],
        ArrowRight:[0,1],
        ArrowDown:[1,0]
      }

      let selectedCells = selectedItemsRef.getState().cells || [];

      let someCellSelected = selectedCells[0];
      let arrowPressed = !!directionMap[key]

      let [rows,cols] = G.getTableDimensions(state,figurePanelId);
      let gridHasRows = rows > 0;




      if( someCellSelected && arrowPressed ){
        event && event.preventDefault();

        let rowArrangedGridData = G.getCompleteGridLayoutData(state,{figurePanelId});

        let direction = directionMap[key]
        let newSelectedPosition = G.getFigurePanelGridCoordByTravelingDirectionFromCell(null,{
          cell:selectedCells[0],
          direction,
          rowArrangedGridData,
          figurePanelId,
          rows,
          cols
        });
        /*

      if( cellValueInputRef && cellValueInputRef.current ){
        cellValueInputRef.current.blur()
      }

      if( temporaryCellValueRef.current ){
        console.log("ACTION DISPATCHED");
        dispatch(A.setCellsValue({cells:selectedCells,figurePanelId,value:temporaryCellValueRef.current}));
        setTemporaryCellValue(null);
      }
      */

        setSelectedItems({cells:[newSelectedPosition]});
      }else if( arrowPressed && gridHasRows ){


        setSelectedItems({cells:[[0,0]]});
      }
    }
